
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks'
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import LocationPicker from "@/components/Location/LocationPicker"

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useToast } from '@/hooks/use-toast';
import { RootState } from '@/store';
import { updateAddress } from '@/store/slices/turfSlice';
import { registerNewVenue, venueUpdateById } from '@/store/thunkMidddleware/turfMiddleware';
import { ButtonWithLoader } from '../ui/buttonwithloader';
import { toast as newToast } from "@/components/ui/sonner";
import { generateGoogleMapUrl } from '@/lib/utils';
import { Link2 } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
const INDIAN_STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat',
  'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh',
  'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab',
  'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh',
  'Uttarakhand', 'West Bengal', 'Delhi', 'Jammu and Kashmir', 'Ladakh'
];

interface TurfAddressFormProps {
  onNext: () => void;
  onBack: () => void;
}


type LocationCoords = {
  lat: number | any;
  lng: number | any;
}

const TurfAddressForm: React.FC<TurfAddressFormProps> = ({ onNext, onBack }) => {
  const dispatch = useAppDispatch();
  const { address, loading, currentOnboardVenueDetails, venueUpdateByIdResponse } = useAppSelector((state: RootState) => state.turf);

  const { toast } = useToast();

  const [localData, setLocalData] = useState(address);
  const [isFormInputChanged, setIsFormInputChanged] = useState(false)
  const [currentLocation,setCurrentLocation]= useState<LocationCoords | null>( null);
  const [allowLocationChange,setAllowLocationChange]= useState( !address?.googleLocationURL);
  // const [locationMethod, setLocationMethod] = useState(address?.isgoogleLink ?"url":"map");
  const [locationMethod, setLocationMethod] = useState("url");

  useEffect(() => {
    setLocalData(address)
  }, [address])
  useEffect(()=>{
    if(currentOnboardVenueDetails?.payload?.address?.isgoogleLink === false   ){
      setLocationMethod("map")
    }
  },[currentOnboardVenueDetails?.payload])
  const handleInputChange = (field: string, value: string | boolean) => {
    setIsFormInputChanged(true)
    const updatedData = { ...localData, [field]: value };
    setLocalData(updatedData);
    dispatch(updateAddress({ [field]: value }));
  };


  const validateForm = (): boolean => {
    const required = ['address', 'locality', 'city', 'state', 'pincode', 'googleLocationURL'];
    const missing = required.filter(field => !localData[field as keyof typeof localData]);

    if (missing.length > 0) {

      newToast.error(`Please fill all required fields: ${missing.join(', ')}`, { closeButton: true })
      return false;
    }

    if (locationMethod === "url") {
      if (!localData.googleLocationURL.includes("maps.app.goo.gl")) {
        newToast.error("Please paste Google Maps share link (maps.app.goo.gl format)");
        return false;
      }
    }

    if (!/^\d{6}$/.test(localData.pincode)) {
      newToast.error('Please enter a valid 6-digit pincode', { closeButton: true })

      return false;
    }

    return true;
  };



  const handleSubmit = () => {

    if (!validateForm()) return;
    if (isFormInputChanged) {
      if (currentOnboardVenueDetails?.payload?._id) {
        updateVenue(currentOnboardVenueDetails?.payload?._id, (res) => {
          if (res?.payload) {
            setIsFormInputChanged(false);
            newToast.success('Address saved!', { closeButton: true })

            onNext();
          }

        })
      } else {
        newToast.error('Venue Id is missing!', { closeButton: true })

      }
    } else {
      newToast.success('Nothing modified!', { closeButton: true })

      onNext();
    }
  };

  const updateVenue = (venueId: String, cb: (res: any) => void) => {
    // The map picker only fills `currentLocation` when the vendor actually
    // touches it this session. Editing anything else — or saving in URL mode —
    // must leave whatever coordinates the venue already has alone rather than
    // overwriting them with [undefined, undefined].
    const pickedCoordinates =
      currentLocation?.lat && currentLocation?.lng
        ? { type: "Point", coordinates: [currentLocation.lng, currentLocation.lat] }
        : currentOnboardVenueDetails?.payload?.address?.locationCoordinates;

    let request = {
      isgoogleLink:locationMethod === "url"?true:false,
      "address": localData.address,
      "locality": localData.locality,
      "city": localData.city,
      "state": localData.state,
      "pincode": localData.pincode,
      "googleLocationURL": localData.googleLocationURL?.trim(),
      ...(pickedCoordinates ? { locationCoordinates: pickedCoordinates } : {}),
    }

    dispatch(venueUpdateById({
      payload: { address: request }, venueId: venueId, callback: (res) => {
        console.log("venueUpdateById:", res)
        if (cb) {
          cb(res)
        }
      }
    }))


  }


  const handleConfirmLocation=(coords:LocationCoords)=>{
      console.log("Current select loactioon",coords)
      if(coords?.lat && coords.lng){
        setCurrentLocation(coords)
        handleInputChange('googleLocationURL', generateGoogleMapUrl(coords.lat,coords.lng))
      }else{
        newToast.error(`Please select valid location`, { closeButton: true })
      }
  }

  const handleLocationReset=()=>{
    setCurrentLocation(null)
    handleInputChange('googleLocationURL', "")

  }

  const onLocationChangeHadler=()=>{
    setAllowLocationChange(true)
  }
  return (
    // <div className="min-h-screen  flex items-center justify-center">
    <>
    <div className="flex items-start justify-center">

      <Card className="w-full max-w-2xl">
        <CardHeader>
          <CardTitle className="text-2xl font-bold">Turf Address</CardTitle>
          <CardDescription>Where is your turf located?</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="address">Address *</Label>
            <Input
              id="address"
              value={localData.address}
              onChange={(e) => handleInputChange('address', e.target.value)}
              placeholder="Enter full address"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="locality">Locality *</Label>
              <Input
                id="locality"
                value={localData.locality}
                onChange={(e) => handleInputChange('locality', e.target.value)}
                placeholder="Enter locality"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="city">City *</Label>
              <Input
                id="city"
                value={localData.city}
                onChange={(e) => handleInputChange('city', e.target.value)}
                placeholder="Enter city"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="state">State *</Label>
              <Select value={localData.state || ""} onValueChange={(value) => handleInputChange('state', value)}>
                <SelectTrigger>
                  <SelectValue placeholder="Select state" />
                </SelectTrigger>
                <SelectContent>
                  {INDIAN_STATES.map((state) => (
                    <SelectItem key={state} value={state}>
                      {state}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label htmlFor="pincode">Pincode *</Label>
              <Input
                id="pincode"
                type="number"
                value={localData.pincode}
                onChange={(e) => handleInputChange('pincode', e.target.value)}
                placeholder="Enter 6-digit pincode"
                maxLength={6}
              />
            </div>
          </div>
          


          {/* {address?.googleLocationURL && 
          
          <div>
          <Label htmlFor="googleLocationURL"> Venue Location URL *</Label>
  
          <div className="flex items-center gap-2 text-sm">
            
                    <Link2 className="w-4 h-4 text-flup-violet" />
                    <a
                      href={address?.googleLocationURL}
                      className="text-flup-violet hover:underline truncate text-sm truncate w-[400px]"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {address?.googleLocationURL}
                    </a>

                    <ButtonWithLoader 
                    className='h-[30px]'
                    onClick={onLocationChangeHadler}>
                      Change
                    </ButtonWithLoader>
                </div>
                
                </div>} */}

        {/* <div className="space-y-2">
            <Label htmlFor="googleLocationURL"> Venue Location URL *</Label>
        
          
            <Input
              id="googleLocationURL"
              type="url"
              value={localData.googleLocationURL}
              onChange={(e) => handleInputChange('googleLocationURL', e.target.value)}
              placeholder="https://maps.google.com/..."
            />
            <p className="text-sm text-flup-ink-3">
              Get this URL by searching your location on Google Maps and copying the link:
            </p>
            <p className="text-sm text-flup-ink-3 ">
              Example link:
              <span className="text-sm text-blue-400 ml-2">https://maps.app.goo.gl/nMnDRV3TZt6vjBVE8 </span></p> 
          </div> */}

          {/* {allowLocationChange &&<div>
            <LocationPicker 
            handleConfirmLocation={handleConfirmLocation}
            handleLocationReset={handleLocationReset}
            address={address}

            />
          </div>} */}




          <div className="space-y-3 pt-2">
  <Label>Venue Location *</Label>

  <Tabs value={locationMethod} onValueChange={(value)=>{
    let isgoogleLink = false
    if(value === "url"){
      isgoogleLink=true;
    }
    handleInputChange("isgoogleLink",isgoogleLink)
    setLocationMethod(value)
  }}>

    <TabsList className="grid w-full grid-cols-2">
      <TabsTrigger value="url">Google Location URL</TabsTrigger>
      <TabsTrigger value="map">Select on Map</TabsTrigger>
    </TabsList>

    {/* URL TAB */}
    <TabsContent value="url">
      <div className="space-y-2">
        <Input
          id="googleLocationURL"
          type="url"
          value={localData.googleLocationURL || ""}
          onChange={(e) =>
            handleInputChange("googleLocationURL", e.target.value)
          }
          placeholder="https://maps.google.com/..."
        />
        {/* <p className="text-sm text-flup-ink-3">
          Paste Google Maps link of your venue.

          <p className="text-sm text-flup-ink-3 ">
              Example link:
              <span className="text-sm text-blue-400 ml-2">https://maps.app.goo.gl/nMnDRV3TZt6vjBVE8 </span></p> 
        </p> */}


        <div className="rounded-lg border bg-muted/40 p-3 text-sm space-y-2">
  <p className="font-medium text-flup-ink-2">📍 How to get correct Google Maps link</p>

  <ol className="list-decimal ml-4 space-y-1 text-flup-ink-2">
    <li>Open Google Maps</li>
    <li>Search your venue location</li>
    <li>Tap <span className="font-semibold">Share</span></li>
    <li>Tap <span className="font-semibold">Copy link</span></li>
    <li>Paste here</li>
  </ol>

  <p className="text-flup-ink-3">
    Example format:
    <span className="ml-1 text-flup-info font-medium break-all">
      https://maps.app.goo.gl/nMnDRV3TZt6vjBVE8
    </span>
  </p>
</div>

      </div>
    </TabsContent>

    {/* MAP TAB */}
    <TabsContent value="map">
      <LocationPicker
        handleConfirmLocation={handleConfirmLocation}
        handleLocationReset={handleLocationReset}
        address={address}
      />
    </TabsContent>

  </Tabs>
</div>



          <div className="flex gap-4 pt-4">
            <Button
              variant="outline"
              onClick={onBack}
              className="flex-1"
              disabled={venueUpdateByIdResponse.isLoading || loading}

            >
              Back
            </Button>
            <ButtonWithLoader
              loaderPosition='right'
              isLoading={venueUpdateByIdResponse.isLoading || loading}
              onClick={handleSubmit}
              className="flex-1 bg-flup-brand hover:bg-flup-brand-press text-white"
              disabled={venueUpdateByIdResponse.isLoading || loading}
            >
              Continue
            </ButtonWithLoader>
          </div>
        </CardContent>
      </Card>
    </div>
    </>
  );
};

export default TurfAddressForm;
